module.exports = {

    data() {
        return {
            placeOptions: {},
            filterFields: ['address_components'],
            autocompleteInput: null,
            autocomplete: null,
            addressParts: {
                street_number: {
                    key: 'short_name',
                    to: 'address_1',
                    join: ''
                },
                route: {
                    key: 'long_name',
                    to: 'address_1',
                    join: ' '
                },
                locality: {
                    key: 'long_name',
                    to: 'city',
                    join: ''
                },
                administrative_area_level_1: {
                    key: 'short_name',
                    to: 'region',
                    join: ''
                },
                country: {
                    key: 'long_name',
                    to: 'country',
                    join: ''
                },
                postal_code: {
                    key: 'short_name',
                    to: 'postal_code',
                    join: ''
                },
            }
        }
    },

    mounted() {
        eventBus.$on('google-api-ready', this.createAutocompleteAddress)
    },

    methods: {

        createAutocompleteAddress(id = 'autocomplete-address') {
            this.autocompleteInput = document.getElementById(id);
            if (!this.autocompleteInput) return;
            this.autocomplete = new google.maps.places.Autocomplete(this.autocompleteInput, this.placeOptions);
            if(this.filterFields){
                this.autocomplete.setFields(this.filterFields);
            }
            this.autocomplete.addListener('place_changed', this.placeChanged);
            this.$nextTick(() => this.createdField())
        },

        createdField(){
            // TODO
        },

        placeChanged() {
            var place = this.autocomplete.getPlace();
            this.setAddressFromPlace(place)
            if (!place.geometry) {
                return;
            }
        },

        setAddressFromPlace(place) {
            for (var key in this.addressParts) {
                this.form[this.addressParts[key].to] = '';
            }
            for (var i = 0; i < place.address_components.length; i++) {
                var addressType = place.address_components[i].types[0];
                if (this.addressParts[addressType]) {
                    var val = (this.addressParts[addressType].join + place.address_components[i][this.addressParts[addressType].key]);
                    if(this.form.hasOwnProperty(this.addressParts[addressType].to)) {
                        this.form[this.addressParts[addressType].to] += val;
                    }
                }
            }
        },
    }
}
